export const ADD_LOADING    = "ADD_LOADING";
export const REMOVE_LOADING = "REMOVE_LOADING";